import { z } from 'zod';

/**
 * Refers to `GetScoringStandardListReq` model
 */
export const standardListFilterSchema = z.object({
  bunriId: z.number().optional(),
  facultyId: z.number().optional(),
  subjectId: z.number().optional(),
  universityId: z.string().optional(),
});

/**
 * Refers to `GetScoringStandardListReq` model
 */
export type StandardListFilterSchema = z.infer<typeof standardListFilterSchema>;
